/**
 * Formats a person's display name for the active UI language.
 *
 * @param firstName - Given name from the API.
 * @param lastName - Family name from the API.
 * @param activeLang - Transloco active language code (e.g. `hu`, `en`).
 * @returns Trimmed full name in locale-appropriate order.
 */
export function formatPersonFullName(firstName: string, lastName: string, activeLang: string): string {
  const first = firstName ?? '';
  const last = lastName ?? '';
  return activeLang === 'hu' ? `${last} ${first}`.trim() : `${first} ${last}`.trim();
}
